import { Box, Hidden } from 'braid-design-system';
import type { Locale } from 'node_modules/@seek/melways-sites/dist';

import SmartHireDesktop from './png/smarthire-desktop.png';
import SmartHireMobile from './png/smarthire-mobile.png';
import SrnDesktop from './png/srn-desktop.png';
import SrnMobile from './png/srn-mobile.png';

import * as styles from './FindRecruiterDialog.css';

interface Props {
  locale: Locale;
}

const FindRecruiterImage = ({ locale }: Props) => {
  let desktopImg = null,
    mobileImg = null;
  switch (locale) {
    case 'en-MY':
    case 'en-HK':
      desktopImg = SmartHireDesktop;
      mobileImg = SmartHireMobile;
      break;
    default:
      desktopImg = SrnDesktop;
      mobileImg = SrnMobile;
      break;
  }

  return (
    <Box
      className={styles.imageContainer}
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="full"
    >
      <Hidden below="desktop">
        <Box
          data-testid="find-recruiter-img"
          className={styles.imageContainer}
          component="img"
          src={desktopImg}
          alt="Person looking for recruiters"
          width="full"
          display="block"
        />
      </Hidden>
      <Hidden above="tablet">
        <Box
          className={styles.imageContainer}
          component="img"
          src={mobileImg}
          alt="Person looking for recruiters"
          width="full"
          display="block"
        />
      </Hidden>
    </Box>
  );
};

export default FindRecruiterImage;
